import React from 'react';
import { enableWhyDidYouRender } from './project-config.json';

/* Browser code, typed without Node's globals. Vite replaces process.env.NODE_ENV
/* at build time, so this is the one name it reads. */
declare const process: { env: { NODE_ENV?: string } };

const whyDidYouRender = {
  init: async () => {
    if (process.env.NODE_ENV === 'development' && enableWhyDidYouRender) {
      const render = await import('@welldone-software/why-did-you-render');
      render.default(React, {
        logOnDifferentValues: false,
        include: [/^HomePage/],
      });
    }
  },
};
export { whyDidYouRender };
